import { render, staticRenderFns } from "./ReportIdentification.vue?vue&type=template&id=c7bfdf18&scoped=true&"
import script from "./ReportIdentification.ts?vue&type=script&lang=ts&"
export * from "./ReportIdentification.ts?vue&type=script&lang=ts&"
import style0 from "./ReportIdentification.vue?vue&type=style&index=0&id=c7bfdf18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bfdf18",
  null
  
)

export default component.exports